import * as React from 'react';

const LoadingPage = () => (
  <div className="container hub-full-width">
    <div className="page-content u-xs-padXl u-flexExpandSides">
      <div className="page-content-header Grid u-flexAlignItemsCenter">
        <div className="Grid-cell u-xs-size1of2">
          <h1>Loading...</h1>
        </div>
      </div>
    </div>
  </div>
);

export default LoadingPage;
